export const SAMPLES_QUERY_KEY = () => ["samples"];